import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { goBack } from 'connected-react-router'
import { compose } from 'recompose'
import { destroy } from 'redux-form'
import { first } from 'lodash'
import { Header } from 'components/layout'
import { setWizard } from 'redux/modules/wizard'
import scrollToError from 'utils/scrollToError'
import { logout } from 'redux/modules/auth'
import styles from './wizard.styl'
import WizardContext from './WizardContext'
import { get } from 'lodash'

const enhance = compose(
  connect(
    state => ({
      wizardSteps: state.wizard.get('steps'),
      locale: state.app.locale.code,
      customization: get(state, 'api.organizations.customization')
    }),
    { goBack, setWizard, destroy,
      logoutFunc: logout
    }
  )
)

class Wizard extends Component {
  static propTypes = {
    noHeader: PropTypes.bool,
    items: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    logout: PropTypes.bool,
    wizardSteps: PropTypes.object,
    route: PropTypes.object,
    history: PropTypes.object,
    wizardProgress: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    setWizard: PropTypes.func.isRequired,
    destroy: PropTypes.func.isRequired,
    logoutFunc: PropTypes.func.isRequired,
    customization: PropTypes.object
  }

  static defaultProps = {
    routes: []
  }

  state = {
    activeFormName: ''
  }

  componentDidMount = async () => {
    const { location, route, history } = this.props

    if (this.props.logout) {
      await this.props.logoutFunc()
    }

    this.handleCheckFirstStep(location, route.routes, history)
    this.props.setWizard(this.props.items.wizard)
    this.handleLockView(true)
  }

  componentWillUnmount = () => {
    this.props.setWizard([])
    this.handleLockView(false)
    this.state.activeFormName && this.props.destroy(this.state.activeFormName)
  }

  handleCheckFirstStep = (location, routes, history) => {
    if (location && location.pathname && routes && routes.length && history) {
      const firstStep = first(routes.filter(r => r.activeId === 1))

      if (firstStep && location.pathname !== firstStep.path) {
        history.push(`${firstStep.path}${location.search}`)
      }
    }
  }

  handleFormInit = formName => {
    this.setState({
      activeFormName: formName
    })
  }

  handleLockView = bool => {
    const bodyClass = document.querySelector('body').classList

    bool ? bodyClass.add('lock') : bodyClass.remove('lock')
  }

  render() {
    const {
      children,
      wizardProgress,
      wizardSteps,
      locale,
      noHeader,
      route,
      location,
      customization
    } = this.props
    const { routes } = route

    const logoUrl = get(customization, 'organization.logoUrl')

    const isLocaleHidden = routes && routes.some(item => {
      return item.path === location.pathname && item.hideLocaleSwitcher
    })

    const childrenContext = {
      locale,
      links: wizardSteps,
      onSubmitFail: scrollToError,
      onFormInit: this.handleFormInit
    }

    return (
      <div className={styles.wrapper}>
        {!noHeader &&
          ((logoUrl && <Header className="visible-xs" isLocaleHidden={isLocaleHidden} logoUrl={logoUrl} />) ||
            <Header className="visible-xs" isLocaleHidden={isLocaleHidden} />)}
        <div className={styles.sidebar}>
          {React.cloneElement(wizardProgress, { links: wizardSteps })}
        </div>
        <div className={styles.main} id="scrollContrainer">
          {!noHeader &&
          ((logoUrl && <Header className="hidden-xs" isLocaleHidden={isLocaleHidden} logoUrl={logoUrl}/>) ||
          <Header className="hidden-xs" isLocaleHidden={isLocaleHidden} />)}
          <div className={styles.content}>
            <div className="container">
              <div className="row">
                {wizardSteps.size > 0 &&
                  <div className="col-xs-12">
                    <WizardContext.Provider value={childrenContext}>
                      {React.cloneElement(children, childrenContext)}
                    </WizardContext.Provider>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default enhance(Wizard)
